import { NavState } from './types';

const initialNavState: NavState = {
  minimizeSidebar: false,
  currentOpenSidebarEventKey: undefined,
  previousOpenSidebarEventKey: undefined,
};

export default initialNavState;
